import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Uf } from '../../components'
import * as ufActionCreators from '../../redux/modules/uf'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class UfContainer extends Component {

  static propTypes = {
    history: PropTypes.object,
    multipleUf: PropTypes.object,
    fetchMultipleUf: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    showErrorFlashMessage: PropTypes.func,
    destroyUf: PropTypes.func,
    hideFlashMessage: PropTypes.func,
    error: PropTypes.array,
    updateSort: PropTypes.func.isRequired,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    filterText: PropTypes.string,
    isLoading: PropTypes.bool,
  }

  async componentDidMount () {
    await this.props.fetchMultipleUf()
  }

  handleRedirectToNew = () => {
    this.props.history.push('/uf/new')
  }

  handleEditResource = (id) => {
    this.props.history.push(`/uf/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyUf(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('uf', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('uf', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleUf.toList().toJSON(),
      'uf',
      ['id', 'nome', 'sigla', 'submercado.id', 'submercado.nome'],
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <Uf
        multipleUf={this.props.multipleUf}
        onRedirectToNew={this.handleRedirectToNew}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading} />
    )
  }
}

function mapStateToProps ({uf, status, sort, filter}) {
  const sortColumn = sort.getIn(['uf', 'sortColumn']) || 'nome'
  const sortDirection = sort.getIn(['uf', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['uf', 'filterText']) || ''

  let map = filterMap(uf, ['nome', 'sigla', 'submercado.nome'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleUf: map,
    sortColumn,
    sortDirection,
    filterText,
    error: status.getIn(['uf', 'error']),
    isLoading: status.getIn(['uf', 'isLoading']),
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...ufActionCreators,
    ...flashMessageAcionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UfContainer)
